// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__35-2e","vLegacy":"SelectSecondary_vLegacy__1Nuyh","error":"SelectSecondary_error__3p12Q","disabled":"SelectSecondary_disabled__3jTr7"};